<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Button
              type="primary"
              icon="md-add"
              class="search_tn"
              data-level="common"
              @click="addListModal = true"
            >新建</Button>
            <Button
              class="top_search_btn"
              icon="md-trash"
              :disabled="selectedList.length ? false : true"
              type="error"
              ghost
              @click="deleteStatus = true"
            >删除</Button>
          </div>
        </div>
      </div>
      <Table
        class="main_table"
        size="large"
        stripe
        border
        :columns="tableHeader"
        :data="tableData"
        @on-selection-change="selectedChange"
      >
        <template slot-scope="{row}" slot="grade">
          <span>{{row.grade}}年级</span>
        </template>
        <template slot-scope="{row}" slot="status">
          <span v-if="row.status === 0">未生成</span>
          <span v-if="row.status === 1">完成</span>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <a class="jump_color" @click="editorAttr(row)">编辑</a>
          <a class="jump_color" @click="seeChapter(row)">查看章节</a>
          <a class="jump_color" @click="startLayingCode(row.id)">开始布码</a>
          <a class="jump_color" @click="startDownloadUrl(row.id)">导出PDF</a>
          <a class="jump_color" v-if="!row.status" @click="answerCardEnd(row.id)">完成</a>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getAnswerCardList"></paging>
    <Modal
      class="top_search_modal"
      v-model="addListModal"
      title="新建/编辑教辅"
      @on-visible-change="addEditorChange"
    >
      <div class="top_search_wrapper">
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="addEditor.name"
          placeholder="请输入教辅名称"
          @on-focus="selectedALl"
          clearable
        />
        <Select class="search_item" v-model="addEditor.subject" placeholder="请选择科目">
          <Option v-for="item in subjectList" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
        <Select class="search_item" v-model="addEditor.grade" placeholder="请选择年级">
          <Option v-for="item in gradesList" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="addListModal = false">取消</Button>
        <Button class="add_record_btn" type="info" @click="confirmAddEditor">确定</Button>
      </div>
    </Modal>
    <Modal class="delete_modal" title="删除" v-model="deleteStatus">
      <p class="delete_tips_info">确定要将这{{selectedList.length}}本教辅删除吗？</p>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="deleteStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" @click="confirmDeleteBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import paging from "../templates/Paging.vue";
import {
  _editorAnswerCard,
  _getAnswerCardList,
  _deleteAnswerCard,
  _startLayingCode,
  _startDownloadUrl,
  _answerCardEnd
} from "../api/api";
import { selectedALLTxt, alertTips } from "../common/common";
import globalData from "../common/Global";
export default {
  components: { paging },
  data() {
    return {
      pageSize: 10, // 每页条数
      currentNum: 0, // 当前页码
      totalNum: 0, // 数据总条数
      addListModal: false, // 新增弹框
      deleteStatus: false, //删除弹框
      selectedList: [], // 已选中项列表
      orderNum: 0, // 删除时序号
      addEditor: {
        id: 0,
        name: "",
        subject: "语文",
        grade: "一"
      },
      tableHeader: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "教辅名",
          key: "name"
        },
        {
          title: "科目",
          key: "subject"
        },
        {
          title: "年级",
          key: "grade",
          slot: "grade"
        },
        {
          title: "章节数量",
          key: "chapterCount"
        },
        {
          title: "PDF状态",
          key: "status",
          slot: "status"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 400
        }
      ],
      tableData: [],
      regionList: [
        {
          value: "beijing",
          label: "北京",
          children: [
            {
              value: "gugong",
              label: "故宫"
            },
            {
              value: "tiantan",
              label: "天坛"
            },
            {
              value: "wangfujing",
              label: "王府井"
            }
          ]
        },
        {
          value: "jiangsu",
          label: "江苏",
          children: [
            {
              value: "nanjing",
              label: "南京",
              children: [
                {
                  value: "fuzimiao",
                  label: "夫子庙"
                }
              ]
            },
            {
              value: "suzhou",
              label: "苏州",
              children: [
                {
                  value: "zhuozhengyuan",
                  label: "拙政园"
                },
                {
                  value: "shizilin",
                  label: "狮子林"
                }
              ]
            }
          ]
        }
      ],
      gradesList: [
        {
          label: "一年级",
          value: "一"
        },
        {
          label: "二年级",
          value: "二"
        },
        {
          label: "三年级",
          value: "三"
        },
        {
          label: "四年级",
          value: "四"
        },
        {
          label: "五年级",
          value: "五"
        },
        {
          label: "六年级",
          value: "六"
        },
        {
          label: "七年级",
          value: "七"
        },
        {
          label: "八年级",
          value: "八"
        },
        {
          label: "九年级",
          value: "九"
        }
      ], //年级列表
      subjectList: [
        {
          label: "语文",
          value: "语文"
        },
        {
          label: "数学",
          value: "数学"
        },
        {
          label: "英语",
          value: "英语"
        }
      ]
    };
  },
  methods: {
    //      确定新增、编辑
    confirmAddEditor() {
      const self = this;
      let dataInfo = {
        id: self.addEditor.id,
        name: self.addEditor.name,
        subject: self.addEditor.subject,
        grade: self.addEditor.grade
      };
      _editorAnswerCard(dataInfo).then(res => {
        if (res.code === 0) {
          self.addListModal = false;
          self.getAnswerCardList();
        }
      });
    },
    //      确定删除
    confirmDeleteBtn() {
      const self = this;
      if (self.selectedList.length > 0) {
        _deleteAnswerCard(self.selectedList[self.orderNum].id).then(res => {
          if (res.code === 0) {
            self.orderNum++;
            if (self.orderNum <= self.selectedList.length - 1) {
              self.confirmDeleteBtn();
            } else {
              self.deleteStatus = false;
              self.getAnswerCardList();
              self.orderNum = 0;
              self.selectedList = [];
            }
          }
        });
      }
    },
    //     勾选变化事件
    selectedChange(msg) {
      this.selectedList = msg;
    },
    //      新增、编辑弹框状态改变
    addEditorChange(boolean) {
      if (!boolean) {
        this.addEditor = {
          id: 0,
          name: "",
          subject: "语文",
          grade: "一"
        };
      }
    },
    //      编辑教辅
    editorAttr(row) {
      console.log("rowData", row);
      this.addListModal = true;
      this.addEditor = {
        id: row.id,
        name: row.name,
        subject: row.subject,
        grade: row.grade
      };
    },
    //      查看章节列表
    seeChapter(row) {
      this.$router.push(`/answer/chapter/${row.id}?id=${row.id}`);
    },
    //      查询答题本列表(我发布的)
    getAnswerCardList(msg) {
      const self = this;
      let params = {
        page: typeof msg === "object" && msg.pageNum ? msg.pageNum - 1 : 0,
        size: self.pageSize,
        sort: "createTime,desc"
      };
      _getAnswerCardList({ params: params })
        .then(res => {
          if (res.code === 0) {
            self.tableData = res.data.content;
            self.totalNum = res.data.total;
          } else {
            //            clearInterval(timer);
          }
        })
        .catch(() => {
          //            clearInterval(timer);
        });
    },
    //     答题本开始布码
    startLayingCode(id) {
      const self = this;
      _startLayingCode(id).then(res => {
        if (res.code === 0) {
          alertTips("success", "拼命布码中");
        }
      });
    },
    //     下载教辅申请
    startDownloadUrl(id) {
      const self = this;
      _startDownloadUrl(id).then(res => {
        if (res.code === 0) {
          let aDom = document.createElement("a");
          let clickEvent = new MouseEvent("click");
          aDom.download = globalData.downLoadPdf + res.data;
          aDom.href = globalData.downLoadPdf + res.data;
          aDom.target = "_blank";
          aDom.dispatchEvent(clickEvent);
        }
      });
    },
    //      答题本完成
    answerCardEnd(id) {
      const self = this;
      _answerCardEnd(id).then(res => {
        if (res.code === 0) {
          alertTips("success", "发布完成");
          self.getAnswerCardList();
        }
      });
    },
    //      input聚焦全选
    selectedALl(e) {
      selectedALLTxt(e);
    }
  },
  created() {
    const self = this;
    self.getAnswerCardList();
  },
  mounted() {}
};
</script>
<style scoped>
.delete_tips_info {
  text-align: center;
  font-size: 18px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/AnswerBook.vue